import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import get from 'lodash/get';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import {
  CLIENT_SETTINGS,
  COORDINATION_SERVICE_LIST,
  CLIENT_ALLOWANCE_ITEMS,
  SETTING_EMPLOYEES_SYNC_ATTENDANCE_SHOW
} from 'src/constants/EndpointUrls';
import { SYNC_JBC_SETTING_FORM } from 'src/constants/FormNames';
import { fetchClientPayrollRuleGroups } from 'src/reducers/fetchSelectOptions';
import { setClientTaskSyncSettingList, saveClientSyncTaskSettings } from 'src/reducers/clients/syncTaskSettings';
import SyncJbcSettingForm from './components/SyncJbcSettingForm';
import { useTranslation, withTranslation } from 'react-i18next';

import styles from './SyncJbcSettings.scss';

const Note = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className={styles.notes}>
        {t('features.Coordinations.SyncJbcSettings.This_is_the_setting_for_API_integration_with_JOBCAN_Attendance')}<br />
        {t('features.Coordinations.SyncJbcSettings.By_setting_the_date_and_time_you_can_get_the_attendance_data_automatically_every_month_or_at_any_time_you_want')}
      </p>
      <div className={styles.innerNotes}>
        <p>
          {t('features.Coordinations.SyncJbcSettings.JOBCAN_Attendance_Setting')}<br />
          {t('features.Coordinations.SyncJbcSettings.You_need_to_set_up_the_CSV_format_on_the_JOBCAN_Attendance_side')}<br />
          <a
            href="https://jobcan-payroll.zendesk.com/hc/ja/articles/360002468813"
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('features.Coordinations.SyncJbcSettings.Help')}
          </a>{t('features.Coordinations.SyncJbcSettings.Please_use_this_as_reference_for_the_setting')}
          {t('features.Coordinations.SyncJbcSettings.If_each_salary_rule_group_has_different_attendance_items_please_set_up_a_CSV_format_for_each_salary_rule_group')}
        </p>
        <ul className="m-list-notes">
          <li>
            {t('features.Coordinations.SyncJbcSettings.Attendance_items_acquired_for_JOBCAN_Payroll_are')}<a href={CLIENT_ALLOWANCE_ITEMS}>{t('features.Coordinations.SyncJbcSettings.these_items')}</a>{t('features.Coordinations.SyncJbcSettings.Other_items_not_acquired_by_JOBCAN_Attendance_will_not_be_acquired_even_if_you_set_them')}
          </li>
        </ul>
        <p className="u-mt20">
          {t('features.Coordinations.SyncJbcSettings.CSV_Format')}<br />
          {t('features.Coordinations.SyncJbcSettings.Link_the_CSV_format_set_in_JOBCAN_Attendance_to_each_salary_rule_group')}<br />
          {t('features.Coordinations.SyncJbcSettings.Please_note_that_API_integration_is_not_possible_without_the_linkage')}
        </p>
        <p className="u-mt20">
          {t('features.Coordinations.SyncJbcSettings.Automatic_linkage_by_date_and_time')}<br />
          {t('features.Coordinations.SyncJbcSettings.By_checking_the_automatic_linkage_checkbox_and_specifying_the_day_and_time_you_can_automatically_retrieve_attendance_data_at_that_time_every_month')}<br />
          {t('features.Coordinations.SyncJbcSettings.For_example_if_the_closing_date_of_attendance_is_on_the_last_day_of_the_month_you_can_set_it_to_05_00_on_the_1st_day_to_get_the_closed_data_automatically')}
        </p>
        <ul className="m-list-notes">
          <li>{t('features.Coordinations.SyncJbcSettings.The_more_employees_you_have_the_longer_it_will_take_to_get_the_data_so_it_is_recommended_to_set_time_at_around_3_00_to_5_00')}</li>
        </ul>
        <p className="u-mt20">
          {t('features.Coordinations.SyncJbcSettings.Employee_Integration_Setting')}<br />
          <a href={SETTING_EMPLOYEES_SYNC_ATTENDANCE_SHOW}>
            {t('features.Coordinations.SyncJbcSettings.Employees_attendance_integration_setting')}
          </a>{t('features.Coordinations.SyncJbcSettings.can_be_set_if_you_want_to_integrate_API_for_each_employee')}<br />
          {t('features.Coordinations.SyncJbcSettings.It_is_set_to_ON_by_default_please_set_it_to_OFF_if_you_have_employees_who_want_to_disable_the_linkage')}
        </p>
      </div>
    </div>
  );
};

const SyncJbcSettingReduxForm = reduxForm({
  form: SYNC_JBC_SETTING_FORM,
  enableReinitialize: true
})(SyncJbcSettingForm);

const ConnectedSettingReduxForm = connect(
  state => ({
    initialValues: {
      clientSyncTaskSettings: get(state, ['clientSyncTaskSettings', 'list', 'data']) || []
    },
    errors: []
  }),
  dispatch => ({
    onSubmit: data => dispatch(saveClientSyncTaskSettings(data))
  })
)(SyncJbcSettingReduxForm);

class SyncJbcSettings extends React.Component {
  componentDidMount() {
    const { dispatch, values } = this.props;
    dispatch(fetchClientPayrollRuleGroups());
    dispatch(setClientTaskSyncSettingList(values.clientSyncTaskSettings));
  }

  render() {
    return (
      <React.Fragment>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.Coordinations.SyncJbcSettings.JOBCAN_Attendance_Integration_Setting')}</h1>
        </div>
        <div className="l-wrap-xl l-contents-wrap">
          <BreadCrumb>
            <BreadCrumb.Item label={this.props.t('features.Coordinations.SyncJbcSettings.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={this.props.t('features.Coordinations.SyncJbcSettings.service_link')} path={COORDINATION_SERVICE_LIST} />
            <BreadCrumb.Item label={this.props.t('features.Coordinations.SyncJbcSettings.JOBCAN_Attendance_Integration_Setting')} />
          </BreadCrumb>
          <Note />
          <div className="u-mt20">
            <ConnectedSettingReduxForm />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(connect()(SyncJbcSettings));
